import {
  CurrentProduct,
  TargetProduct,
  SpendStretchProduct,
  getFirstPromptQualifyingBasketItem,
  getSpendStretchQualifyingBasketItemsTotal,
  hasPromptQualifyingBasketItemQuantity,
} from "@/utils/product/getPromoOffersFromBasket";
import { basketItemWithPromotions } from "@/utils/product/getBasketData";
import { getGwpPercentage } from "@/utils/product/getProductFromPromoMessaging";
import { MessageWithCategoryAndType } from "@/utils/product/getPromoMessaging";

export const hasCurrentQualifyingOffer = (message: string) => {
  const regex =
    /Add this item to your basket(?!.*Add( the)? <a href="https:\/\/www\.johnlewis\.com\/[^\s"]+")/;
  const match = message.match(regex);
  const hasQualifyingOffer = match ? true : false;
  return hasQualifyingOffer;
};

export const hasTwoQualifyingCombinationOffer = (message: string) => {
  const regex = /Add 2 (or more|selected)/;
  const match = message.match(regex);
  const hasTwoQualifyingOffer = match ? true : false;
  return hasTwoQualifyingOffer;
};

export const hasThreeQualifyingCombinationOffer = (message: string) => {
  const regex = /Add 3 (or more|selected)/;
  const match = message.match(regex);
  const hasThreeQualifyingOffer = match ? true : false;
  return hasThreeQualifyingOffer;
};

export const multipleQualifyingCombinationOffer = (
  message: string,
): number | undefined => {
  const hasTwoCombinationOffer = hasTwoQualifyingCombinationOffer(message);
  const hasThreeCombinationOffer = hasThreeQualifyingCombinationOffer(message);
  return hasTwoCombinationOffer ? 2 : hasThreeCombinationOffer ? 3 : undefined;
};

export const getPromptFromCombinationOffer = (
  qualifyingProduct?: CurrentProduct,
  spendStretchProduct?: SpendStretchProduct,
  combinationTargetProducts: Array<TargetProduct> = [],
  basketItems: Array<basketItemWithPromotions> = [],
): MessageWithCategoryAndType | undefined => {
  if (qualifyingProduct?.qualifyingProductQuantity) {
    return hasPromptQualifyingBasketItemQuantity(basketItems, qualifyingProduct)
      ? qualifyingProduct.promoMessage
      : undefined;
  }

  if (spendStretchProduct) {
    return processSpendStretchOffer(spendStretchProduct, basketItems);
  }

  return processTargetProductOffer(combinationTargetProducts, basketItems);
};

const processSpendStretchOffer = (
  spendStretchProduct: SpendStretchProduct,
  basketItems: basketItemWithPromotions[],
): MessageWithCategoryAndType | undefined => {
  const {
    spendStretchTotal: stretchTotal,
    promoMessage: stretchMessage,
    targetProductId,
  } = spendStretchProduct;
  const qualifyingItemsTotal = getSpendStretchQualifyingBasketItemsTotal(
    stretchMessage,
    basketItems,
    targetProductId,
  );
  const spendStretchPercentage = stretchTotal
    ? getGwpPercentage(qualifyingItemsTotal, stretchTotal)
    : 0;

  if (spendStretchPercentage !== 100) {
    return undefined;
  }

  if (targetProductId) {
    const targetProductInBasket = getFirstPromptQualifyingBasketItem(
      basketItems,
      [{ productId: targetProductId, promoMessage: stretchMessage }],
    );
    return targetProductInBasket ? stretchMessage : undefined;
  }

  return stretchMessage;
};

const processTargetProductOffer = (
  combinationTargetProducts: TargetProduct[],
  basketItems: basketItemWithPromotions[],
): MessageWithCategoryAndType | undefined => {
  if (combinationTargetProducts.length === 0) {
    return undefined;
  }

  const targetProductInBasket = getFirstPromptQualifyingBasketItem(
    basketItems,
    combinationTargetProducts,
  );
  return targetProductInBasket?.promoMessage;
};
